import { useMemo, useState } from "react";
import { Invitation } from "@features/invitations/types/invitation";

export function useSelection(rows: Invitation[]) {
    const [selected, setSelected] = useState<Set<string>>(new Set());
    const allSelectedOnPage = useMemo(() => rows.length > 0 && rows.every(r => selected.has(r.invitation_id.toString())), [rows, selected]);

    const toggleAll = () => {
        const next = new Set(selected);
        if (allSelectedOnPage) rows.forEach(r => next.delete(r.invitation_id.toString()));
        else rows.forEach(r => next.add(r.invitation_id.toString()));
        setSelected(next);
    };

    const toggleOne = (id: number, on: boolean) => {
        const next = new Set(selected);
        on ? next.add(id.toString()) : next.delete(id.toString());
        setSelected(next);
    };

    const clear = () => setSelected(new Set());

    return { selected, setSelected, allSelectedOnPage, toggleAll, toggleOne, clear };
}